import {getCommaNumber} from "./format";
import {getSampleRelativePartnerList} from "./sample";
import {useSelector} from "react-redux";

export const defineInfo = {
	service : {
		kind : {
			P : "기간제",
			N : "횟수제"
		},
		name : {
			APPOINTMENT : "개인레슨",
			CLASS : "그룹수업",
			PLACE : "시설이용",
			OPTION : "옵션이용",
			TRANSFER_COMMISSION : "양도 수수료",
			ETC : "기타",
			// PACKAGE는 CS25-8980으로 매출 API에서 사라졌지만 라벨은 남긴다.
			// 이 맵은 주문·결제·환불 상세(PaymentInfo/RefundInfo/PassInfo)도 함께 쓰고,
			// 그쪽 API는 여전히 PACKAGE를 내려줄 수 있다. 지우면 라벨이 "-"로 깨진다.
			PACKAGE : "패키지"
		},
		color : {
			APPOINTMENT : "appointment",
			CLASS : "class",
			PLACE : "place",
			OPTION : "option",
			TRANSFER_COMMISSION : "transferCommission",
			ETC : "etc",
			PACKAGE : "green"
		},
	},
	schedule : {
		state : {
			name : {
				C : "취소",
				E : "출석",
				A : "결석",
				R : "예약",
				W : "대기",
				S : "출석 요청",
				modify_schedule : "예약 변경"
			},
			color : {
				C : "gray",
				E : "green",
				A : "red",
				R : "blue",
				W : "gray",
				S : "green light",
				modify_schedule : "blue light"
			}
		},
		type : {
			1 : "APPOINTMENT",
			2 : "CLASS",
			3 : "OT",
			4 : "CONSULTING",
			5 : "ETC",
			name : {
				1 : "개인레슨",
				2 : "그룹수업",
				3 : "OT",
				4 : "상담",
				5 : "기타"
			},
			color : {
				1 : "purple",
				2 : "orange",
				3 : "purple",
				4 : "purple",
				5 : "gray"
			}
		},
		cancel : {
			path : {
				CRM : "CRM",
				COACH : "강사앱",
				MEMBER : "회원앱"
			},
			name : {
				CRM : "관리자",
				COACH : "강사",
				MEMBER : "회원"
			},
			color : {
				CRM : "black",
				COACH : "blue",
				MEMBER : "purple"
			}
		}
	},
	payment : {
		type : {
			CASH : "현금",
			CARD : "카드",
			TRANSFER : "이체"
		},
		cashReceiptType : {
			MOBILE : "휴대전화",
			BUSINESS_NUMBER : "사업자번호",
			CASH_RECEIPT_CARD : "현금영수증카드"
		},
		kind : {
			NEW : "판매",
			ORDER : "일반",
			RECEIVABLES : "미수금",
			TRANSFER : "양도",
			PASS : "판매",
			UPGRADE : "업그레이드",
			CROSS : "교체",
			REFUND : "환불",
			REPAYMENT : "재결제",
			MERGE : "이용권 결합"
		}
	},
	order : {
		type : {
			PASS : "판매",
			UPGRADE : "업그레이드",
			CROSS : "교체",
			TRANSFER : "양도",
			MERGE : "결합"
		},
		state : {
			COMPLETED : "판매",
			CANCELLED : "취소",
			REFUNDED : "환불",
			REFUNDED_PART : "부분 환불",
			MERGED_PART : "부분 결합"
		}
	}
};

export const getServiceKindName = (serviceKind) => {
	return (serviceKind) ? defineInfo.service.kind[serviceKind.toUpperCase()] || "-" : "-";
};

export const getUseNumber = (serviceKind, useNumber) => {
	return (serviceKind == "N") ? getCommaNumber(useNumber) + "회" : "무제한";
};


export const getPaymentTypeName = (paymentType) => {
	return (paymentType) ? defineInfo.payment.type[paymentType.toUpperCase()] || "-" : "-";
};


export const getServiceTypeName = (serviceType) => {
	return (serviceType) ? defineInfo.service.name[serviceType.toUpperCase()] || "-" : "-";
};

export const getServiceTypeColor = (serviceType) => {
	return (serviceType) ? defineInfo.service.color[serviceType.toUpperCase()] || "-" : "-";
};

export const getScheduleTypeIndex = (value) => {
	const type = typeof value;
	if(type == "number") {
		return value;
	} else if(type == "string") {
		value = value.toUpperCase();
		for(let i = 1; i <= 5; i++) {
			const name = defineInfo.schedule.type[i];
			if(name == value) return i;
		}
	} else if(type == "object") {
		const scheduleState = value.scheduleState;
		const scheduleType = (value.scheduleType || "").toUpperCase();
		if(value.seqPartnerClassSchedule) return 2;
		return getScheduleTypeIndex(scheduleType);
		/*
		const seqPassInfo = value.seqPassInfo;
		if(scheduleType == "CLASS") {
			return 2;
		} else if(scheduleType == "APPOINTMENT") {
			if(scheduleState == "B") return 5;
			if(seqPassInfo == -100) return 4;
			if(seqPassInfo == -999) return 3;
			return 1;
		}
		*/
	}
	return 0;
};

export const getScheduleType = (value) => {
	const index = getScheduleTypeIndex(value);
	return defineInfo.schedule.type[index] || "";
};

export const getScheduleTypeName = (value, lang) => {
	const index = getScheduleTypeIndex(value);
	return defineInfo.schedule.type.name[index] || "";
};

export const getScheduleTypeColor = (value) => {
	const index = getScheduleTypeIndex(value);
	return defineInfo.schedule.type.color[index] || "";
};

export const getScheduleStateName = (state) => {
	return defineInfo.schedule.state.name[state] || "";
};

export const getScheduleStateColor = (state) => {
	return defineInfo.schedule.state.color[state] || "";
};

export const getScheduleCancelPathName = (value) => {
	return defineInfo.schedule.cancel.path[value] || "";
};

export const getScheduleCancelName = (value) => {
	return defineInfo.schedule.cancel.name[value] || "";
};

export const getScheduleCancelColor = (value) => {
	return defineInfo.schedule.cancel.color[value] || "";
};

export const getPartnerBranchName = (partnerInfo, seqPartner, seqPartnerBranch) => {
	partnerInfo = ((partnerInfo || {}).partnerList || []).filter(item => {
		return (item.seqPartner == seqPartner);
	})[0] || {};
	const branchInfo = (partnerInfo.partnerBranches || []).filter(item => {
		return (item.seqPartnerBranch == seqPartnerBranch);
	})[0] || {};
	/*
	const branchInfo = (partnerInfo.branchList || []).filter(item => {
		return (item.seqPartnerBranch == seqPartnerBranch);
	})[0];
	*/
	return branchInfo.branchName || branchInfo.partnerName || "";
};

export const getDetailTitle = (partnerInfo, searchPartner, searchBranch, suffix) => {
	const branchName = getPartnerBranchName(partnerInfo, searchPartner, searchBranch);
	return ((partnerInfo.headquarterYn == "Y" && !partnerInfo.seqPartnerBranch) ?
		branchName + " " : "") + suffix || "";
};

export const isBranchPermission = (partnerInfo) => {
	return (partnerInfo.headquarterYn == "Y" && partnerInfo.seqPartnerBranch == 0);
};

export const getOrderStateName = (orderState) => {
	return defineInfo.order.state[orderState] || "";
};

export const getOrderTypeName = (orderType) => {
	return defineInfo.order.type[orderType] || "";
};
